<div class="ql-container" #container (drop)="dropRoot($event)"></div>
<tsa-link-preview [editor]="quill" (edit)="editLink($event)" (remove)="removeLink($event)"></tsa-link-preview>
